import React from "react";


export default (props) => (
  <div className='main-container'>
    <React.Fragment key={Date.now()}>
      {props.children}
    </React.Fragment>
  </div>
);
